/* global document */

const resetScrollState = () => {
    window.scrollTo(0, 0);
    // focus header because of the accessibility
    const [header] = document.getElementsByTagName('header') || [];
    if (header && header.focus) {
        header.focus();
    }
};

export default resetScrollState;



// WEBPACK FOOTER //
// ./src/client/utils/reset-scroll-state.js